import React from 'react';

import Hero from 'Components/Hero';
import HeroInfo from './HeroInfo';
import HeroImg from '../../images/homepage_Right.png';

export default () => (
  <Hero image={HeroImg}>
    <HeroInfo />
  </Hero>
);
